import { motion } from "framer-motion";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
  const progress = (currentStep / (totalSteps - 1)) * 100;

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="h-1.5 bg-secondary">
        <motion.div
           className="h-full bg-gradient-rose-solid rounded-r-full"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        />
      </div>
      <div className="absolute top-3 right-4">
        <span className="text-[15px] md:text-base font-sans font-medium text-foreground/60">
          Stap {currentStep} van {totalSteps - 1}
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
